import Axios from 'axios';
import {urlBase} from '../config/properties';

export default () => {
    return Axios.create({
        baseURL: urlBase
    })
}